// extracted by mini-css-extract-plugin
export var csatScore = "_o3-5";
export var header = "_o3-1";
export var panelWrapper = "_o3-2";
export var postPreview = "_o3-3";
export var rightContent = "_o3-0";
export var wrappingText = "_o3-4";